// extracted by mini-css-extract-plugin
export default {"sidebar":"WelcomeSidebar_sidebar__5+9Cn","title":"WelcomeSidebar_title__puWnb","list":"WelcomeSidebar_list__Dhbkd","logo":"WelcomeSidebar_logo__wqoag"};